import { useCallback, useState } from 'react';

/**
 * One answer open at a time.
 *
 * Accordion state is kept here rather than inside each row so the band can
 * never end up with two answers open, and so the first question can be open on
 * arrival — a closed wall of questions reads as a list of problems.
 */
export function useFaqAccordion(initial = 0) {
  const [openIndex, setOpenIndex] = useState<number | null>(initial);

  const toggle = useCallback(
    (index: number) => setOpenIndex((current) => (current === index ? null : index)),
    [],
  );

  return { openIndex, toggle };
}
